import { createContext, useContext, useMemo, useState } from "react";

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
    const [direction, setDirection] = useState(1);

    const value = useMemo(() => ({
        direction,
        setDirection
    }), [direction]);

    return (
        <NavigationContext.Provider value={value}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => useContext(NavigationContext);